import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=209c8fc2&"
import script from "./DeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports